module.exports = __webpack_public_path__ + "img/Bingo_Text1.dc67837f.png";